type CsvHeaderMapping<T> = {
  label: string;
  key: keyof T;
};

export const prepareCsvWithHeader = <T>(
  data: T[],
  mapping: CsvHeaderMapping<T>[],
) => {
  const csvFields = mapping.map((m) => m.label);
  const keys = mapping.map((m) => m.key);
  const csvData = data.map((row) => keys.map((key) => row[key]));

  return { csvFields, csvData };
};
